import { Component, OnInit } from '@angular/core';
import { ENDPOINTS } from '@app/core/constants/endpoints';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit {
    year: number;
    links = {
        privacy: ENDPOINTS.urls.policies.privacy,
    };

    ngOnInit(): void {
        this.year = new Date().getFullYear();
    }
}
